import { render } from "./ManageObat.vue?vue&type=template&id=3cf7fae0"
import script from "./ManageObat.vue?vue&type=script&lang=js"
export * from "./ManageObat.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__